//@ts-nocheck
  // DO NOT MODIFY THIS FILE. This file is automatically generated by Tina
  export function gql(strings: TemplateStringsArray, ...args: string[]): string {
    let str = ''
    strings.forEach((string, i) => {
      str += string + (args[i] || '')
    })
    return str
  }
  export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** References another document, used as a foreign key */
  Reference: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type SystemInfo = {
  __typename?: 'SystemInfo';
  filename: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  breadcrumbs: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  template: Scalars['String']['output'];
  collection: Collection;
};


export type SystemInfoBreadcrumbsArgs = {
  excludeExtension?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasPreviousPage: Scalars['Boolean']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
  endCursor: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Document = {
  id: Scalars['ID']['output'];
  _sys?: Maybe<SystemInfo>;
  _values: Scalars['JSON']['output'];
};

/** A relay-compliant pagination connection */
export type Connection = {
  totalCount: Scalars['Float']['output'];
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  getOptimizedQuery?: Maybe<Scalars['String']['output']>;
  collection: Collection;
  collections: Array<Collection>;
  node: Node;
  document: DocumentNode;
  post: Post;
  postConnection: PostConnection;
  main_blog_meta: Main_Blog_Meta;
  main_blog_metaConnection: Main_Blog_MetaConnection;
  pop_posts: Pop_Posts;
  pop_postsConnection: Pop_PostsConnection;
};


export type QueryGetOptimizedQueryArgs = {
  queryString: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PostFilter>;
};


export type QueryMain_Blog_MetaArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMain_Blog_MetaConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Main_Blog_MetaFilter>;
};


export type QueryPop_PostsArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPop_PostsConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Pop_PostsFilter>;
};

export type DocumentFilter = {
  post?: InputMaybe<PostFilter>;
  main_blog_meta?: InputMaybe<Main_Blog_MetaFilter>;
  pop_posts?: InputMaybe<Pop_PostsFilter>;
};

export type DocumentConnectionEdges = {
  __typename?: 'DocumentConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<DocumentNode>;
};

export type DocumentConnection = Connection & {
  __typename?: 'DocumentConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<DocumentConnectionEdges>>>;
};

export type Collection = {
  __typename?: 'Collection';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  documents: DocumentConnection;
};


export type CollectionDocumentsArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DocumentFilter>;
  folder?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentNode = Post | Main_Blog_Meta | Pop_Posts | Folder;

export type PostBlocksContent = {
  __typename?: 'PostBlocksContent';
  body?: Maybe<Scalars['String']['output']>;
};

export type PostBlocks = PostBlocksContent;

export type Post = Node & Document & {
  __typename?: 'Post';
  draft?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['JSON']['output']>;
  blocks?: Maybe<Array<Maybe<PostBlocks>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_image?: Maybe<Scalars['String']['output']>;
  meta_tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RichTextFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostBlocksContentFilter = {
  body?: InputMaybe<StringFilter>;
};

export type PostBlocksFilter = {
  content?: InputMaybe<PostBlocksContentFilter>;
};

export type ImageFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DatetimeFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostFilter = {
  draft?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  body?: InputMaybe<RichTextFilter>;
  blocks?: InputMaybe<PostBlocksFilter>;
  thumbnail?: InputMaybe<ImageFilter>;
  tag?: InputMaybe<StringFilter>;
  date?: InputMaybe<DatetimeFilter>;
  meta_title?: InputMaybe<StringFilter>;
  meta_description?: InputMaybe<StringFilter>;
  meta_image?: InputMaybe<ImageFilter>;
  meta_tags?: InputMaybe<StringFilter>;
};

export type PostConnectionEdges = {
  __typename?: 'PostConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Post>;
};

export type PostConnection = Connection & {
  __typename?: 'PostConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<PostConnectionEdges>>>;
};

export type Main_Blog_Meta = Node & Document & {
  __typename?: 'Main_blog_meta';
  title: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type Main_Blog_MetaFilter = {
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  tags?: InputMaybe<StringFilter>;
};

export type Main_Blog_MetaConnectionEdges = {
  __typename?: 'Main_blog_metaConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Main_Blog_Meta>;
};

export type Main_Blog_MetaConnection = Connection & {
  __typename?: 'Main_blog_metaConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<Main_Blog_MetaConnectionEdges>>>;
};

export type Pop_PostsPost_1 = Post;

export type Pop_PostsPost_2 = Post;

export type Pop_PostsPost_3 = Post;

export type Pop_Posts = Node & Document & {
  __typename?: 'Pop_posts';
  post_1?: Maybe<Pop_PostsPost_1>;
  post_2?: Maybe<Pop_PostsPost_2>;
  post_3?: Maybe<Pop_PostsPost_3>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type Pop_PostsPost_1Filter = {
  post?: InputMaybe<PostFilter>;
};

export type Pop_PostsPost_2Filter = {
  post?: InputMaybe<PostFilter>;
};

export type Pop_PostsPost_3Filter = {
  post?: InputMaybe<PostFilter>;
};

export type Pop_PostsFilter = {
  post_1?: InputMaybe<Pop_PostsPost_1Filter>;
  post_2?: InputMaybe<Pop_PostsPost_2Filter>;
  post_3?: InputMaybe<Pop_PostsPost_3Filter>;
};

export type Pop_PostsConnectionEdges = {
  __typename?: 'Pop_postsConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Pop_Posts>;
};

export type Pop_PostsConnection = Connection & {
  __typename?: 'Pop_postsConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<Pop_PostsConnectionEdges>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPendingDocument: DocumentNode;
  updateDocument: DocumentNode;
  deleteDocument: DocumentNode;
  createDocument: DocumentNode;
  updatePost: Post;
  createPost: Post;
  updateMain_blog_meta: Main_Blog_Meta;
  createMain_blog_meta: Main_Blog_Meta;
  updatePop_posts: Pop_Posts;
  createPop_posts: Pop_Posts;
};


export type MutationAddPendingDocumentArgs = {
  collection: Scalars['String']['input'];
  relativePath: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentUpdateMutation;
};


export type MutationDeleteDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
};


export type MutationCreateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentMutation;
};


export type MutationUpdatePostArgs = {
  relativePath: Scalars['String']['input'];
  params: PostMutation;
};


export type MutationCreatePostArgs = {
  relativePath: Scalars['String']['input'];
  params: PostMutation;
};


export type MutationUpdateMain_Blog_MetaArgs = {
  relativePath: Scalars['String']['input'];
  params: Main_Blog_MetaMutation;
};


export type MutationCreateMain_Blog_MetaArgs = {
  relativePath: Scalars['String']['input'];
  params: Main_Blog_MetaMutation;
};


export type MutationUpdatePop_PostsArgs = {
  relativePath: Scalars['String']['input'];
  params: Pop_PostsMutation;
};


export type MutationCreatePop_PostsArgs = {
  relativePath: Scalars['String']['input'];
  params: Pop_PostsMutation;
};

export type DocumentUpdateMutation = {
  post?: InputMaybe<PostMutation>;
  main_blog_meta?: InputMaybe<Main_Blog_MetaMutation>;
  pop_posts?: InputMaybe<Pop_PostsMutation>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMutation = {
  post?: InputMaybe<PostMutation>;
  main_blog_meta?: InputMaybe<Main_Blog_MetaMutation>;
  pop_posts?: InputMaybe<Pop_PostsMutation>;
};

export type PostBlocksContentMutation = {
  body?: InputMaybe<Scalars['String']['input']>;
};

export type PostBlocksMutation = {
  content?: InputMaybe<PostBlocksContentMutation>;
};

export type PostMutation = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  blocks?: InputMaybe<Array<InputMaybe<PostBlocksMutation>>>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_image?: InputMaybe<Scalars['String']['input']>;
  meta_tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Main_Blog_MetaMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Pop_PostsMutation = {
  post_1?: InputMaybe<Scalars['String']['input']>;
  post_2?: InputMaybe<Scalars['String']['input']>;
  post_3?: InputMaybe<Scalars['String']['input']>;
};

export type PostPartsFragment = { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null };

export type Main_Blog_MetaPartsFragment = { __typename: 'Main_blog_meta', title: string, description?: string | null, image?: string | null, tags?: Array<string | null> | null };

export type Pop_PostsPartsFragment = { __typename: 'Pop_posts', post_1?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, post_2?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, post_3?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null };

export type PostQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type PostQuery = { __typename?: 'Query', post: { __typename: 'Post', id: string, draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null } };

export type PostConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PostFilter>;
}>;


export type PostConnectionQuery = { __typename?: 'Query', postConnection: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'PostConnectionEdges', cursor: string, node?: { __typename: 'Post', id: string, draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null } | null } | null> | null } };

export type Main_Blog_MetaQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type Main_Blog_MetaQuery = { __typename?: 'Query', main_blog_meta: { __typename: 'Main_blog_meta', id: string, title: string, description?: string | null, image?: string | null, tags?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type Main_Blog_MetaConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Main_Blog_MetaFilter>;
}>;


export type Main_Blog_MetaConnectionQuery = { __typename?: 'Query', main_blog_metaConnection: { __typename?: 'Main_blog_metaConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'Main_blog_metaConnectionEdges', cursor: string, node?: { __typename: 'Main_blog_meta', id: string, title: string, description?: string | null, image?: string | null, tags?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type Pop_PostsQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type Pop_PostsQuery = { __typename?: 'Query', pop_posts: { __typename: 'Pop_posts', id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, post_1?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, post_2?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, post_3?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } };

export type Pop_PostsConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Pop_PostsFilter>;
}>;


export type Pop_PostsConnectionQuery = { __typename?: 'Query', pop_postsConnection: { __typename?: 'Pop_postsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'Pop_postsConnectionEdges', cursor: string, node?: { __typename: 'Pop_posts', id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, post_1?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, post_2?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, post_3?: { __typename: 'Post', draft?: boolean | null, title: string, description?: string | null, body?: any | null, thumbnail?: string | null, tag?: string | null, date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_image?: string | null, meta_tags?: Array<string | null> | null, id: string, blocks?: Array<{ __typename: 'PostBlocksContent', body?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null } | null> | null } };

export const PostPartsFragmentDoc = gql`
    fragment PostParts on Post {
  __typename
  draft
  title
  description
  body
  blocks {
    __typename
    ... on PostBlocksContent {
      body
    }
  }
  thumbnail
  tag
  date
  meta_title
  meta_description
  meta_image
  meta_tags
}
    `;
export const Main_Blog_MetaPartsFragmentDoc = gql`
    fragment Main_blog_metaParts on Main_blog_meta {
  __typename
  title
  description
  image
  tags
}
    `;
export const Pop_PostsPartsFragmentDoc = gql`
    fragment Pop_postsParts on Pop_posts {
  __typename
  post_1 {
    ... on Post {
      __typename
      draft
      title
      description
      body
      blocks {
        __typename
        ... on PostBlocksContent {
          body
        }
      }
      thumbnail
      tag
      date
      meta_title
      meta_description
      meta_image
      meta_tags
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  post_2 {
    ... on Post {
      __typename
      draft
      title
      description
      body
      blocks {
        __typename
        ... on PostBlocksContent {
          body
        }
      }
      thumbnail
      tag
      date
      meta_title
      meta_description
      meta_image
      meta_tags
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  post_3 {
    ... on Post {
      __typename
      draft
      title
      description
      body
      blocks {
        __typename
        ... on PostBlocksContent {
          body
        }
      }
      thumbnail
      tag
      date
      meta_title
      meta_description
      meta_image
      meta_tags
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
}
    `;
export const PostDocument = gql`
    query post($relativePath: String!) {
  post(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PostParts
  }
}
    ${PostPartsFragmentDoc}`;
export const PostConnectionDocument = gql`
    query postConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PostFilter) {
  postConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PostParts
      }
    }
  }
}
    ${PostPartsFragmentDoc}`;
export const Main_Blog_MetaDocument = gql`
    query main_blog_meta($relativePath: String!) {
  main_blog_meta(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...Main_blog_metaParts
  }
}
    ${Main_Blog_MetaPartsFragmentDoc}`;
export const Main_Blog_MetaConnectionDocument = gql`
    query main_blog_metaConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: Main_blog_metaFilter) {
  main_blog_metaConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...Main_blog_metaParts
      }
    }
  }
}
    ${Main_Blog_MetaPartsFragmentDoc}`;
export const Pop_PostsDocument = gql`
    query pop_posts($relativePath: String!) {
  pop_posts(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...Pop_postsParts
  }
}
    ${Pop_PostsPartsFragmentDoc}`;
export const Pop_PostsConnectionDocument = gql`
    query pop_postsConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: Pop_postsFilter) {
  pop_postsConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...Pop_postsParts
      }
    }
  }
}
    ${Pop_PostsPartsFragmentDoc}`;
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
  export function getSdk<C>(requester: Requester<C>) {
    return {
      post(variables: PostQueryVariables, options?: C): Promise<{data: PostQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostQueryVariables, query: string}> {
        return requester<{data: PostQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostQueryVariables, query: string}, PostQueryVariables>(PostDocument, variables, options);
      },
    postConnection(variables?: PostConnectionQueryVariables, options?: C): Promise<{data: PostConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostConnectionQueryVariables, query: string}> {
        return requester<{data: PostConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PostConnectionQueryVariables, query: string}, PostConnectionQueryVariables>(PostConnectionDocument, variables, options);
      },
    main_blog_meta(variables: Main_Blog_MetaQueryVariables, options?: C): Promise<{data: Main_Blog_MetaQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Main_Blog_MetaQueryVariables, query: string}> {
        return requester<{data: Main_Blog_MetaQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Main_Blog_MetaQueryVariables, query: string}, Main_Blog_MetaQueryVariables>(Main_Blog_MetaDocument, variables, options);
      },
    main_blog_metaConnection(variables?: Main_Blog_MetaConnectionQueryVariables, options?: C): Promise<{data: Main_Blog_MetaConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Main_Blog_MetaConnectionQueryVariables, query: string}> {
        return requester<{data: Main_Blog_MetaConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Main_Blog_MetaConnectionQueryVariables, query: string}, Main_Blog_MetaConnectionQueryVariables>(Main_Blog_MetaConnectionDocument, variables, options);
      },
    pop_posts(variables: Pop_PostsQueryVariables, options?: C): Promise<{data: Pop_PostsQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Pop_PostsQueryVariables, query: string}> {
        return requester<{data: Pop_PostsQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Pop_PostsQueryVariables, query: string}, Pop_PostsQueryVariables>(Pop_PostsDocument, variables, options);
      },
    pop_postsConnection(variables?: Pop_PostsConnectionQueryVariables, options?: C): Promise<{data: Pop_PostsConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Pop_PostsConnectionQueryVariables, query: string}> {
        return requester<{data: Pop_PostsConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: Pop_PostsConnectionQueryVariables, query: string}, Pop_PostsConnectionQueryVariables>(Pop_PostsConnectionDocument, variables, options);
      }
    };
  }
  export type Sdk = ReturnType<typeof getSdk>;

// TinaSDK generated code
import { createClient, TinaClient } from "tinacms/dist/client";

const generateRequester = (
  client: TinaClient,
  options?: { branch?: string }
) => {
  const requester: (
    doc: any,
    vars?: any,
    options?: { branch?: string },
    client
  ) => Promise<any> = async (doc, vars, options) => {
    let url = client.apiUrl
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf('/')
      url = client.apiUrl.substring(0, index + 1) + options.branch
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url,
    })

    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} }
  }

  return requester
}

/**
 * @experimental this class can be used but may change in the future
 **/
export const ExperimentalGetTinaClient = () =>
  getSdk(
    generateRequester(
      createClient({
        url: "https://content.tinajs.io/1.4/content/50f40e89-6eb0-4f8a-91b3-2de8301293f3/github/main",
        queries,
      })
    )
  )

export const queries = (
  client: TinaClient,
  options?: {
    branch?: string
  }
) => {
  const requester = generateRequester(client, options)
  return getSdk(requester)
}

  